exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".matches-header-row{width:100%;display:flex;align-items:center;justify-content:space-between;gap:12px}.matches-header-text{min-width:0}.bookmarks-title-inline,.matches-header-text{display:inline-flex;align-items:baseline;gap:6px}.bookmarks-title-inline{white-space:nowrap;max-width:100%}.filter-toggle-btn{width:34px;height:34px;border-radius:10px;border:1px solid rgba(0,0,0,.08);background:#eee;color:#111;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0}.filter-toggle-btn:focus,.filter-toggle-btn:hover{background:#e5e5e5;border-color:rgba(0,0,0,.14)}.filter-toggle-btn .fa{font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/filter.toggle.shared.css
// module id = 1192
// module chunks = 0